// Standings the list request accepts (pxCaseListStatus in the shared schema) and
// the two named selections offered in the filter. The automatic preset keeps an
// over case while the viewer has not read its latest activity, then drops it
const casesStatusPresets = {
  kinds: ['new', 'ongoing', 'done', 'doneUnread'],
  custom: ['new', 'ongoing', 'done'],
  active: ['new', 'ongoing', 'doneUnread'],
  all: ['new', 'ongoing', 'done'],
};

export default casesStatusPresets;
